import { jsx as _jsx } from "react/jsx-runtime";
import { CommunityMemberList } from './CommunityMemberList';
import { SpaceMemberList } from './SpaceMemberList';
export const MemberList = ({ spaceId }) => {
    if (spaceId)
        return _jsx(SpaceMemberList, { spaceId: spaceId }, void 0);
    return _jsx(CommunityMemberList, {}, void 0);
};
export { MemberCard } from './MemberCard';
export { WhySpaceMemberList } from './WhySpaceMemberList';
export { SpaceMembersModal } from './SpaceMembersModal';
//# sourceMappingURL=index.js.map